import { render } from "./MMMemberAssessment.vue?vue&type=template&id=204973f4"
import script from "./MMMemberAssessment.vue?vue&type=script&lang=js"
export * from "./MMMemberAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__